module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightpage",
    attrs: {
      "id": "d7e4"
    }
  }, [_c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A DAVID & CHARLES BOOK"), _c('br'), _vm._v("Copyright © David & Charles Limited 2009, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("David & Charles is an F+W Media Inc. company"), _c('br'), _vm._v("4700 East Galbraith Road"), _c('br'), _vm._v("Cincinnati, OH 45236")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("First published in the UK in 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This digital edition published in 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Text, illustrations and photography copyright © David & Charles Limited 2009, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Project designs copyright © Susan Briscoe, Alice Butcher & Ginny Farquhar, Lynne Edwards, Marion Elliot, Christina Marsh, Ellen Kharade, Sally Southern, Jo Verso and Dorothy Wood 2009, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Susan Briscoe, Alice Butcher & Ginny Farquhar, Lynne Edwards, Marion Elliot, Christina Marsh, Ellen Kharade, Sally Southern, Jo Verso and Dorothy Wood have asserted their right to be identified as authors of this work in accordance with the Copyright, Designs and Patents Act, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic or mechanical, by photocopying, recording or otherwise, without prior permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The designs in this book are copyright and must not be made for resale.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The author and publisher have made every effort to ensure that all the instructions in the book are accurate and safe, and therefore cannot accept liability for any resulting injury, damage or loss to persons or property, however it may arise.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Names of manufacturers, paper ranges and other products are provided for the information of readers, with no intention to infringe copyright or trademarks.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("ISBN-13: 978-0-7153-3877-3 epub"), _c('br'), _vm._v("ISBN-10: 0-7153-3877-3 epub")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("ISBN-13: 978-0-7153 -3887-2 pdf"), _c('br'), _vm._v("ISBN-10: 0-7153-3887-0 pdf")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e60"
    }
  }, [_vm._v("David & Charles publish high quality books on a wide range of subjects. For more great book ideas visit: "), _c('b', [_c('a', {
    attrs: {
      "href": "http://www.rucraft.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.rucraft.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e65"
    }
  }, [_vm._v("For templates please see end of book or download them free at: "), _c('a', {
    attrs: {
      "href": "http://www.rucraft.co.uk/how_to_sew_templates.php",
      "target": "_blank"
    }
  }, [_vm._v("www.rucraft.co.uk/how_to_sew_templates.php")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9bc71da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_9780715338773_epub_part1.vue
// module id = 63
// module chunks = 0